import React from 'react';
import IconSelect from '../icons/IconSelect';

const ButtonSelect = ({name, onClick}) => {
  return (
    <button className="btn btn--select" onClick={onClick}>
      <span>{name}</span>
      <IconSelect />
    </button>
  );
}

export default ButtonSelect;